import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-799dbf8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]

import { ref, onMounted } from "vue";
import { useStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchHistory',
  props: {
    category: {}
  },
  emits: ["reSearch"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;

const store = useStore();
const user = store.state.AuthModule.user;

const searchHistory = ref<string[]>([]);



const localStorageKey = `searchHistory_${user.tenancy}_${props.category}`;

onMounted(() => {
  searchHistory.value = JSON.parse(
    localStorage.getItem(localStorageKey) || "[]"
  );
});

const updateSearchHistory = (searchText: string) => {
  const index = searchHistory.value.indexOf(searchText);
  if (index > -1) {
    searchHistory.value.splice(index, 1);
  }
  searchHistory.value.unshift(searchText);
  // if (searchHistory.value.length > 10) {
  //   searchHistory.value.length = 10;
  // }
  // 更新 localStorage 中的搜索历史
  localStorage.setItem(localStorageKey, JSON.stringify(searchHistory.value));
};

const deleteSearchHistory = (index: number) => {
  console.log("deleteSearchHistory", index);
  searchHistory.value.splice(index, 1);
  localStorage.setItem(localStorageKey, JSON.stringify(searchHistory.value));
};

const reSearch = (searchText: string) => {
  emit("reSearch", searchText);
};

__expose({
  updateSearchHistory,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchHistory.value, (item, index) => {
    return _withDirectives((_openBlock(), _createElementBlock("span", {
      class: "badge bg-secondary cursor-pointer p-2 m-2 history-item",
      key: index
    }, [
      _createElementVNode("span", {
        class: "overflow-hidden text-color",
        onClick: ($event: any) => (reSearch(item))
      }, _toDisplayString(item), 9, _hoisted_1),
      _createElementVNode("span", {
        class: "badge bg-danger cursor-pointer delete-icon",
        onClick: _withModifiers(($event: any) => (deleteSearchHistory(index)), ["prevent"])
      }, "x", 8, _hoisted_2)
    ])), [
      [_vShow, index < 5]
    ])
  }), 128))
}
}

})